<script>
  import { markRaw } from 'vue';
  import Chart from 'chart.js';
  import { Bar, mixins } from 'vue-chartjs';
  import chartjsPluginDatalabels from 'chartjs-plugin-datalabels';

  Chart.Tooltip.positioners.custom = (elements) => {
    const view = elements[0]._view;
    return {
      x: view.x,
      y: view.y < 50 ? 50 : view.y,
    };
  };

  export default {
    extends: Bar,
    mixins: [mixins.reactiveProp ],
    props: {
      options: {
        type: Object,
        required: true,
      },
      chartData: {
        type: Object,
        required: true,
      },
    },
    // vue-chartjs 3 の描画関数は Vue 2 形式（引数で createElement を受け取る）。
    // 移行ビルドはコンポーネント自身の render にしか Vue 2 形式の変換を掛けず、
    // extends で継承した render には h が渡らず落ちるので、ここで受けて委譲する。
    render(createElement) {
      return Bar.render.call(this, createElement);
    },
    methods: {
      // vue-chartjs 3 の renderChart と同じ処理だが、Chart のインスタンスを markRaw してから data に入れる。
      // Vue 3 は data に入れたオブジェクトを Proxy で包むので、そのままだと destroy() が
      // Proxy 越しに呼ばれ、chart.js がアニメーションの登録（元オブジェクト）と一致を取れずに
      // 破棄後も描画を続けて「Cannot read properties of null (reading 'clearRect')」で落ちる。
      renderChart(data, options) {
        if (this.$data._chart) this.$data._chart.destroy();
        this.$data._chart = markRaw(new Chart(this.$refs.canvas.getContext('2d'), {
          type: 'bar',
          data: data,
          options: options,
          plugins: this.$data._plugins,
        }));
      },
    },
    mounted() {
      // customの場合tooltipの初期位置を設定
      if (this.options['tooltips'] && this.options.tooltips['position'] === 'custom') {
        if (!this.options.tooltips['xAlign']) this.options.tooltips['xAlign'] = 'center';
        if (!this.options.tooltips['yAlign']) this.options.tooltips['yAlign'] = 'bottom';
      }
      this.addPlugin(chartjsPluginDatalabels);
      this.renderChart(this.chartData, this.options);
    },
  };
</script>
